import { render, staticRenderFns } from "./uploaddragicp.vue?vue&type=template&id=4f02694b"
import script from "./uploaddragicp.vue?vue&type=script&lang=js"
export * from "./uploaddragicp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports